import type { ComponentCombinationItem, ComponentRates } from "../types/api";

type FrontRates = Pick<ComponentRates, "doors" | "drawer_fronts" | "fronts_mixed">;

export const FRONT_TYPE_VALUES = ["doors", "drawer_fronts", "mixed"] as const;

export function frontTypesQueryParam(selection: readonly string[]): string | undefined {
    if (selection.length === 0 || FRONT_TYPE_VALUES.every((value) => selection.includes(value))) {
        return undefined;
    }
    return selection.join(",");
}

export function buildFrontTypeDistribution(rates: FrontRates) {
    return [
        {
            label: "Doors",
            value: Math.max(0, rates.doors.count - rates.fronts_mixed.count),
        },
        {
            label: "Drawer fronts",
            value: Math.max(0, rates.drawer_fronts.count - rates.fronts_mixed.count),
        },
        { label: "Mixed", value: rates.fronts_mixed.count },
    ];
}

const FRONT_TYPE_ORDER = ["Doors", "Drawer fronts", "Mixed"];

// Fixed order keeps slice colours stable as cross-filters change the counts.
export function frontTypeDistributionFromCombos(items: ComponentCombinationItem[]) {
    return FRONT_TYPE_ORDER.flatMap((label) => {
        const item = items.find((i) => i.description === label);
        return item ? [{ label, value: item.count }] : [];
    });
}
